<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>统计管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/stockDetail')">代理库存明细统计</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
        <el-form-item label="代理手机号">
              <el-input style="width:300px" 
              v-model="filters.userPhone" 
              clearable placeholder="请输入代理手机号"></el-input>
            </el-form-item>

            <el-form-item label='商品'>
            <el-input
              style="width:300px"
              v-model="filters.goodName"
              placeholder="请输入商品名称"
            >
            </el-input>
          </el-form-item>
      

          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>

            <el-button
              style="margin-left:10px"
              @click="excelOut(1)"
              type="primary"
              size="small"
            >导出</el-button>

            <el-button
              style="margin-left:10px"
              @click="excelOut(2)"
              type="primary"
              size="small"
            >导出全部</el-button>
            

          </el-form-item>

        </el-form>
      </div>

      <div class="contain_body">
        <el-table
          ref="dataTable"
          v-loading="listLoading"
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column
            prop="userName"
            label="代理名称"
          >
          </el-table-column>

          <el-table-column
            prop="userPhone"
            label="代理手机号"
          >
          </el-table-column>

          <el-table-column
            prop="userGrade"
            label="代理等级"
          >
          </el-table-column>

          <el-table-column
            prop="goodName"
            label="商品名称"
          >
          </el-table-column>

          <el-table-column
            prop="goodPrice"
            label="商品价格"
          >
          </el-table-column>

          <el-table-column
            prop="goodNum"
            label="商品数量"
          >
          </el-table-column>

        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>


  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
var _ = require("lodash");
export default {
  name: "fakeSaleData",
  created() {},

  data() {
    return {
      totalMoney: 0,
      subListVisible: false,
      listLoading: false,
      picList: [],
      filters: {
       userPhone: null,
       goodName: null
      },
      page_num: 1,
      keywords: "",
      pickerOptions1: 1,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      detailListLoading: false,
      tableDetailData: [],
      tableHeight:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
  },
  methods: {
    goDown(){
      this.$refs.dataTable.bodyWrapper.scrollTop =this.$refs.dataTable.bodyWrapper.scrollHeight;
    },
    goTop(){
      this.$refs.dataTable.bodyWrapper.scrollTop =0;
    },
    showDetailInfos(row) {
      let that = this;
      that.subListVisible = true;

      this.page_size = 10;
      this.page_num = 1;
      this.searchDetail(row.role_type);
    },
    excelOut(type) {
      var that = this;
      if(type == 1){
        var url =
        "/manager/user/pc/normal_user_stock_excel?token=" +
        localStorage.getItem("api_token");
        if (!that.filters.userPhone && !that.filters.goodName) {
          that.$message.error({
            showClose: true,
            message: "请输入手机号或商品名",
            duration: 2000
          });
        return; 
        }
        if(that.filters.userPhone){
           url = url + "&userPhone=" + that.filters.userPhone;
        }
       if(that.filters.goodName){
        url = url + "&goodName=" + that.filters.goodName;
       }
      url = url + "&type=" + 1
      top.location.href = url;
    }else {
     let params = {
        token: localStorage.getItem("api_token"),
        type: 2
      }
      API.normal_user_stock_excel(params)
      .then(
        function(result) {
          if (result.key == 1000) {
            that.$message.success({
              showClose: true,
              message: result.message,
              duration: 2000
          });
        }else if(result.key == 0){
          that.$message.error({
              showClose: true,
              message: result.message,
              duration: 2000
          });
        }
      },
      function(err) {
        that.listLoading = false;
        that.$message.error({
          showClose: true,
          message: err.toString(),
          duration: 2000
        });
      }
    ).catch(function(err){
      that.listLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
        })
      }
    },
    handleSearch() {
      this.search();
    },
    search() {
      let that = this;
      let params = {
        token: localStorage.getItem("api_token"),
        pageNum: that.page_num,
        pageSize: that.page_size
      };
      if (that.filters.userPhone) {
        params.userPhone = that.filters.userPhone;
      }
      if (that.filters.goodName) {
        params.goodName = that.filters.goodName;
      } 
      that.listLoading = true;
      API.normal_user_stock_detail(params)
        .then(
          function(result) {
            that.listLoading = false;
            if (result.key == 1000) {
              that.tableData = result.result.list;
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
            }else if(result.key == 0){
              that.$message.error({
              showClose: true,
              message: result.message,
              duration: 2000
          });
            }
          },
          function(err) {
            that.listLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading = false;
          console.error(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.handleSearch();
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/stockDetail.vue